import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LayoutActionLoadError } from '@shared/store/actions/layout.action';
import { NGXLogger } from 'ngx-logger';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ReduceToClearRequestAction, ReduceToClearRequestViewAction } from './reduce-to-clear-request.actions';
import { ReduceToClearRequestService } from '../../service/reduce-to-clear-request.service';

@Injectable()
export class ReduceToClearRequestEffects {
  loadReduceToClearRequestListRequested$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReduceToClearRequestAction.requestList),
      tap((action) =>
        this.logger.debug('@Effect Reduce to Clear Request List Requested: ' + JSON.stringify(action.criteriaObj))
      ),
      switchMap((action) => {
        return this.reduceToClearRequestService.getReduceToClearRequestList(action.criteriaObj).pipe(
          map((data: any) => ReduceToClearRequestAction.responseList({ data })),
          catchError((err) => of(new LayoutActionLoadError(err)))
        );
      })
    );
  });

  ReduceToClearRequestView$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ReduceToClearRequestViewAction.request),
      tap((_) => this.logger.debug('@Effect [Reduce To Clear Request View] View request ')),
      switchMap((action) => {
        return this.reduceToClearRequestService.getReduceToClearRequestView(action.requestNo).pipe(
          map((data: any) => {
            return ReduceToClearRequestViewAction.response({
              data
            });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private reduceToClearRequestService: ReduceToClearRequestService
  ) {}
}
